import React, { useState, useEffect } from 'react';
import { isBlankString, containsBadCharacter } from '../../helpers/helpers';
import ConfirmationModal from '../Shared/Modals/ConfirmationModal';
import { EditableTagProps, Tag } from './types';

const EditableTag = ({ editable, tag, entityIndex, editEntity, onTableEntities }:EditableTagProps) => {
  const [currentTagId, setCurrentTagId] = useState(tag.id);
  useEffect(() => setCurrentTagId(tag.id), [tag, editable]);
  const [modal, setModal] = useState<JSX.Element|null>(null);

  const handleSaveClick = () => {
    if (!isBlankString(tag.id)) {
      const entity = JSON.parse(JSON.stringify(onTableEntities[entityIndex]));
      entity.tags.forEach((entityTag:Tag) => {
        if (entityTag._id === tag._id) {
          entityTag.id = currentTagId;
        }
      });
      editEntity(entity, entity.extra_data);
    }
  };

  const handleDeleteClick = () => {
    const entity = JSON.parse(JSON.stringify(onTableEntities[entityIndex]));
    entity.tags = entity.tags.filter((entityTag:Tag) => entityTag._id !== tag._id);
    editEntity(entity, entity.extra_data);
  };

  const handleInputChange = (event:React.ChangeEvent<HTMLInputElement>) => {
    if (containsBadCharacter(event.target.value)) {
      return;
    }
    if (event.target.value !== ' ') {
      setCurrentTagId(event.target.value);
    }
  };

  return (
    <>
      {modal}
      {editable ? (
        <label className="pp-ww">
          <input
            type="text"
            name="editable-tag"
            className="input-tag-entities"
            value={currentTagId}
            onChange={(event) => handleInputChange(event)}
          />
          <button className="btn-tag-edit-save" onClick={handleSaveClick}>
            <i className="mdi mdi-check" />
          </button>
          <button
            className="btn-tag-edit-close"
            onClick={() => setModal(
              <ConfirmationModal
                show={true}
                onHide={() => setModal(null)}
                modalConfig={{
                  titleClassName: 'm-delete-entity-h',
                  bodyClassName: 'm-delete-entity-b',
                  actionsClassName: 'm-delete-entity-b',
                  confirmClassName: 'm-delete-entity-confirm'
                }}
                modalContent={{
                  headerContent: ' ',
                  bodyContent: 'Are you sure you want to delete this tag from the Entity Server?',
                  confirmContent: 'Yes, Delete tag'
                }}
                confirmAction={handleDeleteClick}
              />
            )}
          >
            <i className="mdi mdi-close" />
          </button>
        </label>
      ) : (
        <label
          className="pp-ww"
          style={{
            height: '30px',
            paddingTop: '6px',
            width: '62px',
            display: 'inline-block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {currentTagId + '\n'}
        </label>
      )}
    </>
  );
};
export default EditableTag;
